import { useEffect } from "react";
import { appInsights } from "../../../../../config/appInsights";
import CustomInputField from "../../../../CustomHTMLElements/CustomInputField";
import {
  boardOfDirectorsDocumentType,
  IBusinessOwnersInformation,
} from "../../../Interfaces";
import useDocumentViewer from "../../../../../NewComponents/CustomViewDocumentHandler/CustomViewDocumentHandler";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { DownloadUploadedDocument } from "../../../../../NewComponents/UploadedDocumentCards/UploadedDocumentCard.component";
import { documentApprovalStatusString } from "../../../../AggregatorOnboardingReview/util";
import { auditRoleList, isAudit } from "../../../../../helpers/roleTypes";

interface IBusinessOwnersInformationProps {
  data: IBusinessOwnersInformation[];
  setActionData: React.Dispatch<React.SetStateAction<{}>>;
  funderId: number;
}

const BusinessOwnersInformation = ({
  data,
  setActionData,
  funderId,
}: IBusinessOwnersInformationProps) => {
  const { handleViewDocument } = useDocumentViewer();

  const loggedInUser = useSelector(
    (state: RootState) => state?.authReducer?.loggedInUser
  );

  useEffect(() => {
    appInsights.trackPageView({
      name: "BusinessOwnersInformation.tsx",
      isLoggedIn: true,
    });
  }, []);

  return (
    <div className="table-view speed-1x animated fadeInRight">
      {data && data?.length > 0 ? (
        data?.map(
          ({
            firstName,
            gender,
            dateOfBirth,
            address,
            identityNumber,
            countryCode,
            governmentIdFilePath,
            governmentIdApprovalStatus,
            funderPersonId,
            state,
            city,
            bvn,
            lastName,
            proofOfAddressApprovalStatus,
            govtIdentityType,
            proofOfAddressFilePath,
          }: IBusinessOwnersInformation) => {
            return (
              <>
                <div className="row">
                  <div className="col-md-5">
                    <CustomInputField
                      label="First Name"
                      type="text"
                      name="firstName"
                      defaultValue={firstName}
                      disabled
                    />
                    <CustomInputField
                      label="Gender"
                      type="text"
                      name="gender"
                      defaultValue={gender}
                      disabled
                    />
                    <CustomInputField
                      label="Date of Birth"
                      type="date"
                      name="dateOfBirth"
                      defaultValue={
                        dateOfBirth ? dateOfBirth.split("T")[0] : ""
                      }
                      disabled
                    />
                    <CustomInputField
                      label="Residential Address"
                      type="text"
                      name="address"
                      defaultValue={address!}
                      disabled
                    />
                    <CustomInputField
                      label="Identification"
                      type="text"
                      name="identityNumber"
                      defaultValue={identityNumber!}
                      disabled
                    />
                    <CustomInputField
                      label="Country"
                      type="text"
                      name="countryCode"
                      defaultValue={countryCode!}
                      disabled
                    />

                    <div className="mb-5">
                      <DownloadUploadedDocument
                        name={"ID Upload"}
                        pathname={governmentIdFilePath}
                        handleView={() =>
                          handleViewDocument(false, governmentIdFilePath)
                        }
                      />

                      <div className="d-flex ml-5">
                        <div className="d-flex">
                          {governmentIdApprovalStatus ===
                            documentApprovalStatusString?.DECLINED && (
                            <button
                              className="btn advancly-red-btn btn-md"
                              disabled
                            >
                              Declined
                            </button>
                          )}
                          {governmentIdApprovalStatus ===
                            documentApprovalStatusString?.APPROVED && (
                            <button
                              className="btn advancly-green-btn btn-md"
                              disabled
                            >
                              Approved
                            </button>
                          )}
                        </div>

                        {governmentIdApprovalStatus ===
                          documentApprovalStatusString?.PENDING &&
                          !isAudit(
                            [...loggedInUser?.roles],
                            [...auditRoleList]
                          ) && (
                            <>
                              <button
                                type="button"
                                className="btn advancly-btn btn-md"
                                data-toggle="modal"
                                data-target="#funderPeopleDocumentsApprovalModal"
                                // disabled={handleDisableDocumentAction(loggedInUser)}
                                onClick={() =>
                                  setActionData({
                                    actionType: "approve",
                                    data: {
                                      data: {
                                        id: funderPersonId,
                                        documentType: govtIdentityType,
                                        funderId,
                                      },
                                      documentType:
                                        boardOfDirectorsDocumentType?.GOVERNMENT_ID,
                                    },
                                  })
                                }
                              >
                                Approve
                              </button>
                              <button
                                type="button"
                                className="btn btn advancly-off-2-btn btn-md ml-3"
                                data-toggle="modal"
                                data-target="#funderPeopleDocumentsApprovalModal"
                                // disabled={handleDisableDocumentAction(loggedInUser)}
                                onClick={() =>
                                  setActionData({
                                    actionType: "decline",
                                    data: {
                                      data: {
                                        id: funderPersonId,
                                        documentType: govtIdentityType,
                                        funderId,
                                      },
                                      documentType:
                                        boardOfDirectorsDocumentType?.GOVERNMENT_ID,
                                    },
                                  })
                                }
                              >
                                Decline
                              </button>
                            </>
                          )}
                      </div>
                    </div>

                    <div className="mb-5">
                      <DownloadUploadedDocument
                        name={"Proof of Address"}
                        pathname={proofOfAddressFilePath}
                        handleView={() =>
                          handleViewDocument(false, proofOfAddressFilePath)
                        }
                      />

                      <div className="d-flex ml-5">
                        <div className="d-flex">
                          {proofOfAddressApprovalStatus ===
                            documentApprovalStatusString?.DECLINED && (
                            <button
                              className="btn advancly-red-btn btn-md"
                              disabled
                            >
                              Declined
                            </button>
                          )}
                          {proofOfAddressApprovalStatus ===
                            documentApprovalStatusString?.APPROVED && (
                            <button
                              className="btn advancly-green-btn btn-md"
                              disabled
                            >
                              Approved
                            </button>
                          )}
                        </div>

                        {proofOfAddressApprovalStatus ===
                          documentApprovalStatusString?.PENDING &&
                          !isAudit(
                            [...loggedInUser?.roles],
                            [...auditRoleList]
                          ) && (
                            <>
                              <button
                                type="button"
                                className="btn advancly-btn btn-md"
                                data-toggle="modal"
                                data-target="#funderPeopleDocumentsApprovalModal"
                                // disabled={handleDisableDocumentAction(loggedInUser)}
                                onClick={() =>
                                  setActionData({
                                    actionType: "approve",
                                    data: {
                                      data: {
                                        id: funderPersonId,
                                        documentType: govtIdentityType,
                                        funderId,
                                      },
                                      documentType:
                                        boardOfDirectorsDocumentType?.PROOF_OF_ADDRESS,
                                    },
                                  })
                                }
                              >
                                Approve
                              </button>
                              <button
                                type="button"
                                className="btn btn advancly-off-2-btn btn-md ml-3"
                                data-toggle="modal"
                                data-target="#funderPeopleDocumentsApprovalModal"
                                // disabled={handleDisableDocumentAction(loggedInUser)}
                                onClick={() =>
                                  setActionData({
                                    actionType: "decline",
                                    data: {
                                      data: {
                                        id: funderPersonId,
                                        documentType: govtIdentityType,
                                        funderId,
                                      },
                                      documentType:
                                        boardOfDirectorsDocumentType?.PROOF_OF_ADDRESS,
                                    },
                                  })
                                }
                              >
                                Decline
                              </button>
                            </>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <CustomInputField
                      label="Last Name"
                      type="text"
                      name="lastName"
                      defaultValue={lastName!}
                      disabled
                    />

                    <CustomInputField
                      label="Nationality"
                      type="text"
                      name="countryCode"
                      defaultValue={countryCode!}
                      disabled
                    />

                    <CustomInputField
                      label="BVN"
                      type="text"
                      name="bvn"
                      defaultValue={bvn!}
                      disabled
                    />

                    <CustomInputField
                      label="City"
                      type="text"
                      name="city"
                      defaultValue={city!}
                      disabled
                    />

                    <CustomInputField
                      label="State"
                      type="text"
                      name="state"
                      defaultValue={state!}
                      disabled
                    />
                  </div>
                  <div>
                    <p>
                      -----------------------------------------------------------------------------
                    </p>
                    <p>
                      -----------------------------------------------------------------------------
                    </p>
                  </div>
                </div>
              </>
            );
          }
        )
      ) : (
        <div className="d-flex justify-content-center align-items-center">
          <p> Business Owners Information Not Available </p>
        </div>
      )}
    </div>
  );
};

export default BusinessOwnersInformation;
